import React, { useEffect, useState } from 'react';
import InputLinks from '../Assets/linksData'
import BackCard from '../Assets/backCard'
import { Fade } from 'react-reveal';
import { Button,  Dropdown, Icon, Input, Label, Loader, Tab } from 'semantic-ui-react';
import useGetArticles from '../../Dashboard/Assets/Hooks/fetchArticles';
import { toast } from 'react-toastify';
import GConf from '../../AssetsM/generalConf';
import axios from 'axios';
 
 
 
const AddArticles = ({tableData,GetArticleData,EnterKyPressed,articleNow,setArticleNow,updateBtnState,AddArticleToList}) =>{
    return (<>
            <div className='card card-body  mb-2 border-div'>
                <h5>Ajouter article</h5> 
                <datalist id="articlesList">
                    {tableData.map((test) =>
                    <option key={test.key} value={test.value}>{test.text}</option>
                    )}
                </datalist>
                <Input icon='pin' list="articlesList"  onBlur={ (e) => GetArticleData(e.target.value)} size="small" iconPosition='left' placeholder='Desg'  fluid className='mb-1 shadow-sm' /> 
                <input type='text' className='form-control form-control-lg mb-3' placeholder='Scan article'   onKeyPress={(e) => EnterKyPressed(e)} autoFocus={true} />
                
                <div className='m-2 text-secondary '><b> {articleNow.A_Code}  | {articleNow.Name} </b></div>

                <Input icon='asl' type='number' value={articleNow.Prix_achat} placeholder='Prix achat'  onChange={ (e) => setArticleNow({ ...articleNow, Prix_achat : e.target.value}) } size="small" iconPosition='left'   fluid className='mb-1 shadow-sm' />
                <Input icon='asl' type='number' value={articleNow.Prix_vente} placeholder='Prix vente'  onChange={ (e) =>  setArticleNow({ ...articleNow, Prix_vente : e.target.value}) } size="small" iconPosition='left'   fluid className='mb-1 shadow-sm' />
                <Input icon='asl' type='number' value={articleNow.Quantite} placeholder='qte'  onChange={ (e) => setArticleNow({ ...articleNow, Quantite : e.target.value}) } size="small" iconPosition='left'    fluid className='mb-1 shadow-sm' />
                
                <br />
                <Button disabled={updateBtnState}  className='rounded-pill bg-system-btn' onClick={AddArticleToList}>  <Icon name='edit outline' /> Ajouter</Button>
            </div>
    </>)
}
function BondEPage() {
    /*#########################[Const]##################################*/
    const [bonsD, setBonsD] = useState({genre:'Entre', fournisseur: '', articles:[]})
    const [BE_ID, setBEID] = useState('')
    const [articleNow, setArticleNow] = useState({})
    const [tableData, setTableData] = useState([]);
    const [fournisseurList , setFSList] = useState([]);
    const [articleList, setArticleList] = useState([]);
    const [toUpdatedList, setTUpList] = useState([]);
    const [loaderState, setLS] = useState(false)
    const [updateBtnState, setUpdateBS] = useState(false)
    const [autofocusState, setAutoFocus] = useState(false)
     
    let Offline = JSON.parse(localStorage.getItem(`${GConf.PID}_Offline`));
    const panes = [
        {
            menuItem: { key: 'start', icon: 'add circle', content: 'Entrer ' }, 
            render: () => <Tab.Pane attached={false}> <AddArticles tableData={tableData} GetArticleData={GetArticleData} EnterKyPressed={EnterKyPressed} articleNow={articleNow} setArticleNow={setArticleNow} updateBtnState={updateBtnState} AddArticleToList={AddArticleToList} /> </Tab.Pane>,
        },
        {
            menuItem: { key: 'articles', icon: 'star', content:  <>Articles <Label className='bg-danger' size='tiny'>{bonsD.articles.length}</Label></> }, 
            render: () => 
                        <Tab.Pane attached={false}>
                             
                            <h5>Listes des Articles</h5>    
                            {bonsD.articles.map( (val) => <ArticleListCard key={val.id} dataA={val}/>)}
                            <br />
                        </Tab.Pane>,
        },
        {
            menuItem: { key: 'client', icon: 'check circle', content: 'Terminer' }, 
            render: () =><> <Tab.Pane attached={false}><ButtonsCard /></Tab.Pane></>,
        },
        
    ]

    /*#########################[UseEffect]##################################*/
    useEffect(() => {
        //get stock
        axios.post(`${GConf.ApiLink}/stock`, {
            PID : GConf.PID,
          })
          .then(function (response) {
               let TableNow = []
               response.data.map( (dta) => {TableNow.push({value : dta.A_Code, text : dta.Name, key: dta.PK})})
               setTableData(TableNow)
               setArticleList(response.data)       
          }).catch((error) => {
            if(error.request) {
                toast.error(<><div><h5>Probleme de Connextion</h5> Chargement des article sur votre ordinateur  </div></>, GConf.TostInternetGonf)   
                let TableNow = []
                Offline.stock.map( (dta) => {TableNow.push({value : dta.A_Code, text : dta.Name, key: dta.PK})})
                setTableData(TableNow)
                setArticleList(Offline.stock)
            }
        });
         

    }, [])

    /*#########################[Function]##################################*/
    const AddArticleToList = ()=>{
        if (!articleNow.A_Code) {toast.error("Code à barre Invalide !", GConf.TostErrorGonf)}
        else if (!articleNow.Name || articleNow.Name === '') {toast.error("Nom Invalide !", GConf.TostErrorGonf)}
        else if (!articleNow.Prix_achat || articleNow.Prix_achat === '') {toast.error("Achat Invalide !", GConf.TostErrorGonf)}
        else{
            const searchObject = bonsD.articles.find((article) => article.A_Code == articleNow.A_Code);
            if (searchObject) {
                let IndexOfArticle = bonsD.articles.findIndex((article) => article.A_Code == articleNow.A_Code)
                bonsD.articles[IndexOfArticle].Quantite =  parseInt(articleNow.Quantite)
                bonsD.articles[IndexOfArticle].Prix_achat =  parseInt(articleNow.Prix_achat)
                bonsD.articles[IndexOfArticle].Prix_vente =  parseInt(articleNow.Prix_vente)
                // toUpdatedList[IndexOfArticle].NewQte = toUpdatedList[IndexOfArticle].NewQte + parseInt(articleNow.Value)
                setArticleNow({})
                setAutoFocus(false)
            } else {
                 
                let arrayToAdd = {id: articleNow.PK , A_Code: articleNow.A_Code, Name: articleNow.Name,  Quantite: articleNow.Quantite, Prix_achat: articleNow.Prix_achat, Prix_vente: articleNow.Prix_vente }
                bonsD.articles.push(arrayToAdd) 
                let arrayToUpdate = {A_Code : articleNow.A_Code, Name: articleNow.Name, Quantite: articleNow.Quantite, Prix_achat: articleNow.Prix_achat, Prix_vente: articleNow.Prix_vente}
                toUpdatedList.push(arrayToUpdate)
                setArticleNow({}) 
                setAutoFocus(false)
            }
        }

    }
    const GetArticleData = (value) =>{
        const searchObject = articleList.find((article) => article.A_Code == value);
        if (searchObject) {
            setArticleNow(searchObject);
            setAutoFocus(true)
            
        }else{
            toast.error('Article Indéfine ', GConf.TostSuucessGonf)
        }
    }
    const UpdateStock = () =>{
        setLS(true)
        setUpdateBS(true)
        axios.post(`${GConf.ApiLink}/stock/update`, {
            PID : GConf.PID,
            artList: bonsD.articles,
            fournisseur: bonsD.fournisseur,
          })
          .then(function (response) {    
            if(response.data.BE_ID) {
                toast.success("Article Modifier !", GConf.TostSuucessGonf)
                setBEID(response.data.BE_ID)  
                 
                setLS(false)   
            }
            else{
                toast.error('Erreur Indéfine ', GConf.TostSuucessGonf)
                setLS(false)
            }
          }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Le Bon n'as pas été enregistreé </div></>, GConf.TostInternetGonf)   
              setLS(false)
            }
          });

    }
    const RemoveArticleFromList = (value) =>{
        const searchObject= bonsD.articles.findIndex((article) => article.A_Code === value);
        const searchObjectTwo = toUpdatedList.findIndex((article) => article[0] === value);
        bonsD.articles.splice(searchObject, 1);
        toUpdatedList.splice(searchObjectTwo, 1);
        let resteArticles = bonsD.articles;
        setBonsD({...bonsD, articles: resteArticles})
    }
    
    const EnterKyPressed = (e) =>{
        if (e.which == 13) {
            GetArticleData(e.target.value)
        }  
        //  else if (e.which == 32) {
        //     if (bonsD.articles.length != 0) {
        //         const lastElement = bonsD.articles[factureD.articles.length - 1]
        //         AddMoreQte(lastElement.A_Code,e.target.value)
        //     }
        //  }
         else {
             //console.log(e.which)
         } 
            
    }
    
    const AddByKeyPressed = (e) =>{
        if (e.which == 13) {
            AddArticleToList()
        }              
    }

    /*#########################[Card]##################################*/
    const ArticleListCard = (props) =>{
        return(<>
                    <div className='card shadow-sm p-2 mb-1 border-div  '>
                        <div className='row'>
                            <div className='col-12 col-md-5 text-start align-self-center'>
                                {props.dataA.Name}
                            </div>
                            <div className='col-10 col-md-6 align-self-center text-start'><b>achat : {props.dataA.Prix_achat} | vente : {props.dataA.Prix_vente} | Qte : {props.dataA.Quantite} </b>  </div>
                            <div className='col-2 col-md-1 align-self-center'><Button disabled={updateBtnState} icon="times" className='rounded-circle p-2 text-white bg-danger' onClick={() => RemoveArticleFromList(props.dataA.A_Code)}></Button></div>
                        </div>
                    </div>
                </>)
    }
    const ButtonsCard = () =>{
        return (<>
                <div className='card card-body  mb-2 border-div'>
                    <h5>Buttons</h5>
                    <div className='row mb-2'>
                        <div className='col-12'>
                            <Button  className='rounded-pill bg-system-btn' disabled={updateBtnState}  fluid onClick={UpdateStock}><Icon name='edit outline' /> Mettre à jour <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                        </div>
                        {/* <div className='col-5'>
                            <Button  className='rounded-pill btn-imprimer' disabled={!updateBtnState}  fluid onClick={(e) => PrintFunction('printBES')}><Icon name='print' /> Imprimer</Button>
                        </div> */}
                    </div>
                </div>
        </>)
    }
    // const AddArticles = () =>{
    //     return (<>
    //             <div className='card card-body  mb-2 border-div'>
    //                 {/* <h5>Selectioner Fournisseur</h5> 
    //                 <datalist id="fournisseurList">
    //                     {fournisseurList.map((fourniss,index) =>
    //                     <option key={index} value={fourniss.Four_ID}>{fourniss.Four_Name} - {fourniss.Four_Code_Fiscale}</option>
    //                     )}
    //                 </datalist>
    //                 <Input icon='truck' list="fournisseurList"  onChange={ (e) => setBonsD({...bonsD, fournisseur:e.target.value})} size="small" iconPosition='left' placeholder={bonsD.fournisseur}  fluid className='mb-1 shadow-sm' /> 
    //                 */}
    //                 <h5>Ajouter article</h5> 
    //                 <datalist id="articlesList">
    //                     {tableData.map((test) =>
    //                     <option key={test.key} value={test.value}>{test.text}</option>
    //                     )}
    //                 </datalist>
    //                 <Input icon='pin' list="articlesList"  onBlur={ (e) => GetArticleData(e.target.value)} size="small" iconPosition='left' placeholder='Desg'  fluid className='mb-1 shadow-sm' /> 
    //                 <input type='text' className='form-control form-control-lg mb-3' placeholder='Scan article'   onKeyPress={(e) => EnterKyPressed(e)} autoFocus={true} />
                    
    //                 <div className='m-2 text-secondary '><b> {articleNow.A_Code}  | {articleNow.Name} </b></div>
 
    //                 <Input icon='asl' type='number' value={articleNow.Prix_achat} placeholder='Prix achat'  onChange={ (e) => setArticleNow({ ...articleNow, Prix_achat : e.target.value}) } size="small" iconPosition='left'   fluid className='mb-1 shadow-sm' />
    //                 <Input icon='asl' type='number' value={articleNow.Prix_vente} placeholder='Prix vente'  onChange={ (e) => {articleNow.Prix_vente = e.target.value}} size="small" iconPosition='left'   fluid className='mb-1 shadow-sm' />
    //                 <Input icon='asl' type='number' value={articleNow.Quantite} placeholder='qte'  onChange={ (e) => {articleNow.Quantite = e.target.value}} size="small" iconPosition='left'    fluid className='mb-1 shadow-sm' />
                    
    //                 <br />
    //                 <Button disabled={updateBtnState}  className='rounded-pill bg-system-btn' onClick={AddArticleToList}>  <Icon name='edit outline' /> Ajouter</Button>
    //             </div>
    //     </>)
    // }



    return (  <>
        <BackCard data={InputLinks.backCard.nv}/>
        <br />
        <div className='container-fluid'>
            <Tab menu={{  pointing: true  }} panes={panes} />
        </div>
    </>);
}

export default BondEPage;